export default __webpack_public_path__ + "static/media/Quail-510x600.6d85bc27.jpg";